import ContactForm from './ContactForm'

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl font-bold mb-4 text-gray-900 text-center">
            Get in Touch
          </h2>
          <p className="text-gray-600 mb-12 text-center text-lg">
            有项目想法或合作机会？欢迎通过表单联系我！
          </p>

          {/* 联系表单 */}
          <div className="bg-gray-50 rounded-lg p-8 shadow-sm border border-gray-200 mb-8">
            <div className="mb-6 flex items-center gap-2 text-sm text-green-600">
              <span className="inline-block w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
              <span>已连接到后端 API - 数据将实时提交到数据库</span>
            </div>
            <ContactForm />
          </div>

          {/* 其他联系方式 */}
          <div className="text-center text-gray-600 mb-6">
            或者通过以下方式联系：
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            <a
              href="mailto:your.email@example.com"
              className="bg-gray-50 p-6 rounded-lg hover:shadow-md transition border border-gray-200"
            >
              <div className="text-3xl mb-2">📧</div>
              <div className="font-semibold text-gray-900">Email</div>
              <div className="text-gray-600 text-sm">your.email@example.com</div>
            </a>
            <a
              href="https://github.com/yourusername"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-50 p-6 rounded-lg hover:shadow-md transition border border-gray-200"
            >
              <div className="text-3xl mb-2">💻</div>
              <div className="font-semibold text-gray-900">GitHub</div>
              <div className="text-gray-600 text-sm">@yourusername</div>
            </a>
            <a
              href="https://linkedin.com/in/yourprofile"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-50 p-6 rounded-lg hover:shadow-md transition border border-gray-200"
            >
              <div className="text-3xl mb-2">💼</div>
              <div className="font-semibold text-gray-900">LinkedIn</div>
              <div className="text-gray-600 text-sm">Connect</div>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact
